import payment from './pay-money.vue'

export default{
    components:{
        payment,
    },
    data() {
        return {
            resmessage:{},//发送的数据信息
            respondVisible:false,//弹框的状态
        }
    },
    methods: {
          //撤回消息
          recallMessage(api,params,operation){
            // console.log(api,params,operation);
            this.$confirm('您确定要撤回这条消息吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                api({
                  params: params
                }).then(res => {
                  if (res.resultCode == 1) {
                    //做一些刷新操作
                    operation();
                    this.$message.success(res.errorMsg)
                  } else {
                    this.$message.error(res.errorMsg)
                  }
                })
              }).catch(() => {
              })
          },
          payTeacher(item){
            console.log(item)
            this.resmessage={...item};
            this.respondVisible=true;
          }
    },
   
}